import styled, { css } from 'styled-components';
import { styles, mixins } from '4all-ui/styles';
import {
  GRAY_LIGHT_ONE,
  GRAY_NORMAL_LIGHTEST,
  GRAY_REGULAR_DARK,
  GREEN_LIGHTER,
} from '../../styles/variables';

export const SelectList = styled.div`
  ${mixins.flexPosition({ align: 'center' })}
  line-height: 47px;
  width: 100%;
  height: 40px;
  border-radius: ${styles.borders.RADIUS_1};
  background-color: ${styles.colors.WHITE};
  box-shadow: inset 0 1px 0 0 ${GRAY_NORMAL_LIGHTEST};
  border: solid 1px ${GRAY_REGULAR_DARK};
  padding: 0 14px;
  position: relative;
  margin: 15px 0 0 0;

  ${({ showSelected }) =>
    !showSelected &&
    css`
      height: 0px;
      border: none;
      margin-top: 0px;
    `};

  > div {
    width: 100%;
    min-height: 40px;
    max-height: 200px;
    border-radius: 3px;
    background-color: ${styles.colors.WHITE};
    box-shadow: 0 3px 6px 2px rgba(0, 0, 0, 0.1);
    border: solid 1px rgba(0, 0, 0, 0.1);
    position: absolute;
    margin-top: 5px;
    top: 110%;
    z-index: 999;
    left: 0px;

    ul {
      text-align: left;
      margin: 0;
      padding: 0;
      max-height: 160px;
      overflow-y: auto;

      li {
        padding-left: 14px;
        list-style: none;
        line-height: 40px;

        &:hover {
          background-color: ${GRAY_LIGHT_ONE};
        }
      }
    }
  }
`;

export const Caret = styled.span`
  position: absolute;
  right: 15px;
  border: solid 1px ${GREEN_LIGHTER};
  border-width: 0 3px 3px 0;
  padding: 5px;
  transform: rotate(45deg);
`;



// WEBPACK FOOTER //
// ./src/components/SelectList/style.js